import React from "react";
import {Link} from "react-router-dom"
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-bg">
      <div className="container">
        <div className="row">
          <div className="col-2 d-none d-md-block"></div>
          <div className="col-3 col-md-2">
            <p className="footer-titles"> Contact Us</p>
            <p className="footer-text">
              <i class="fa fa-phone" aria-hidden="true"></i> +91 9823453456{" "}
            </p>
            <p className="contact-email">
              <i class="fa fa-envelope" aria-hidden="true"></i>{" "}
              contact@idecloud.com
            </p>
          </div>
          <div className="col-3 col-md-2">
            <p className="footer-titles">Company</p>
            <p className="footer-text">
              About Us <br />
              Our Team
            </p>
          </div>
          <div className="col-3 col-md-2">
            <p className="footer-titles">IDE-Cloud</p>
            <p className="footer-text">
              Product Tour <br />
              Pricing <br />
              All Features <br />
              <Link to="/free-trial">Free trial</Link>  <br />
              <Link to="/request-demo"> Book a demo</Link>  <br />
              <Link to="/blogs">Blogs</Link>
            </p>
          </div>
          
          <div className="col-3 col-md-2">
            <p className="footer-titles" style={{"padding-left":"5px"}}>Connect with us </p>{" "}
            <p className="footer-text">
              <a
                href="#"
                className="fa fa-facebook-official fa-fw fa-2x"
              ></a>
              <a
                href="#"
                className="fa fa-linkedin-square fa-fw fa-2x"
              ></a>
              <a
                href="#"
                className="fab fa-instagram fa-fw fa-2x"
              ></a>
              <a
                href="#"
                className="fab fa-twitter-square fa-fw fa-2x"
              ></a>
            </p>
          </div>
        </div>
        <div className="row bottom">
          <hr />
          <div className="col-1 col-sm-2 col-lg-4"></div>
          <div className="col-10 col-sm-8 col-lg-4">
            <p style={{"text-align":"center"}}>
              <a href="#">Privacy Policy</a> | <a href="#">Terms of Service</a>{" "}
              | <a href="#">Refund Policy</a>
              
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
